import { defineMessages } from 'react-intl';

const localizedStrings = defineMessages({
  OK: {
    id: 'General.OK',
    defaultMessage: 'OK',
  },
  Cancel: {
    id: 'General.Cancel',
    defaultMessage: 'Cancel',
  },
  Save: {
    id: 'General.Save',
    defaultMessage: 'Save',
  },
});

export default localizedStrings;



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/localizedStrings.js